import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Button } from '../../../../../components/ui/Button';
import { Modal } from '../../../../../components/ui/Modal';
import { updateStatusHistoryDetail } from '../../../../../features/orderDetails/orderDetailsThunks';

/**
 * Edits the free-text observation attached to one event of the status history.
 *
 * Only the note is editable — the status, its substatus and its timestamp are
 * the audit trail and are rewritten through the status editor, never here.
 *
 * @param {object} props
 * @param {object|null} props.event - The timeline entry being edited.
 * @param {() => void} props.onClose
 * @param {object} props.order
 * @param {(message: string) => void} props.onError
 */
const EditHistoryDetailModal = ({ event, onClose, order, onError }) => {
  const dispatch = useDispatch();
  const [details, setDetails] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setDetails(event?.details || '');
  }, [event]);

  const handleSave = async () => {
    if (!event || !order.delivery?.id) return;
    setSaving(true);
    try {
      await dispatch(
        updateStatusHistoryDetail({
          orderId: order.id,
          deliveryId: order.delivery.id,
          statusId: event.id,
          details,
        })
      ).unwrap();
      onClose();
    } catch (error) {
      onError(error);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal isOpen={Boolean(event)} onClose={onClose} title="Editar Detalle del Estado" busy={saving}>
      <div className="flex flex-col gap-4">
        {event && (
          <p className="text-sm text-text-secondary text-center -mt-4">
            {event.statusLabel}
            {event.substatusLabel && `: ${event.substatusLabel}`}
          </p>
        )}

        <div>
          <label className="block text-xs font-bold uppercase tracking-wider text-text-muted mb-1.5">
            Detalle / Observación
          </label>
          <textarea
            rows={3}
            value={details}
            onChange={(e) => setDetails(e.target.value)}
            className="w-full bg-transparent border border-border rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:border-ninja-green transition-colors resize-none"
          />
        </div>
      </div>

      <div className="flex items-center justify-end gap-3 mt-6">
        <Button
          variant="subtle"
          pill
          onClick={onClose}
          disabled={saving}
        >
          Cancelar
        </Button>
        <Button
          variant="primary"
          pill
          onClick={handleSave}
          loading={saving}
          loadingLabel="Guardando..."
        >
          Guardar
        </Button>
      </div>
    </Modal>
  );
};

export default EditHistoryDetailModal;
